import Button from 'components/Button'
import styles from './styles.module.scss'

interface IButtonGroupsProps {
  toggle: React.MouseEventHandler<any>
  formId: string
  isSubmitting?: boolean
}

const ButtonGroup = (props: IButtonGroupsProps) => {
  const { toggle, formId, isSubmitting = false } = props

  return (
    <div className={styles.actionBtns}>
      <Button color="light" onClick={toggle} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button form={formId} type="submit" color="info" isLoading={isSubmitting} loadingText="Saving...">
        Save
      </Button>
    </div>
  )
}

export default ButtonGroup
